
import moment from 'moment';
import { updatePermissions } from 'redux/modules/auth/action';
import { getPermissions } from 'utils/api'

export const textTruncateByLength = (str, length) => {
    if(!str) return '';
    if (str.length > length) {
        return str.substring(0, length) + '...';
    } else {
        return str;
    }
}

export const textTruncateByWords = (str, length) => {
    if(!str) return '';
    if (str.length > length) {
        str = str.substring(0, length) + '...';
        str = str.substring(0, Math.min(str.length, str.lastIndexOf(" ")));
        return str;
    } else {
        return str;
    }
}

export const getRandomColor = () =>  {
    const getRandomNumber = (low, high) => Math.floor(Math.random() * (high - low + 1)) + low;
    let h_range = [0, 360];
    let s_range = [60, 90];
    let l_range = [15, 60];
    let a_range = [1, 1];

    let hue = getRandomNumber(h_range[0], h_range[1]);
    let saturation = getRandomNumber(s_range[0], s_range[1]);
    let lightness = getRandomNumber(l_range[0], l_range[1]);
    let alpha = getRandomNumber(a_range[0] * 100, a_range[1] * 100) / 100;

    return `hsl(${hue}, ${saturation}%, ${lightness}%, ${alpha})`;
}

export const formatDate = (date) => {
    return moment(date).format('MMMM DD, YYYY');
    //let stillUtc = moment.utc(date).toDate();
    //return moment(stillUtc).local().format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
};

export const formatDateWithTime = (date) => {
    if(!date) return '';
    return moment(date).format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
};

export const numberWithCommas = (x) => {
    if(!Number.isInteger(x)) return '';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const getInfluenceName = (sourceName) => {
    switch(sourceName) {
        case 'twitter': return 'Followers';
        case 'facebook': return 'people like this';
        case 'youtube': return 'subscribers';
        case 'rss': return '';
        case 'web': return '';
        default: return 'Followers';
    }
}

const comparePermissionArr = (array1, array2) => {
    return array1.length === array2.length && array1.every((value, index) => array2.includes(value))
}

export async function checkPermissions(currentPermissions, callback, permissionName) {
    let updatedUserData = await getPermissions();
    let updatedPermissions = updatedUserData.content.permissions;

    if(!comparePermissionArr(updatedPermissions, currentPermissions)) { 
        updatePermissions(updatedUserData.content);
    } 
    if(updatedPermissions && updatedPermissions.includes(permissionName)) {
        callback();
    }
}

export const sortAlphabetically = (arr, nameValue) => {
    if(!Array.isArray(arr)) return [];
    let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
    return arr.sort((a, b) => collator.compare(a[nameValue], b[nameValue]));
    // return arr.sort((a, b) => a[nameValue].localeCompare(b[nameValue], undefined, {numeric: true,
    //     sensitivity: 'base'}));
};
